/**
 * Site-Wide Search Modal App
 * Provides global product search functionality
 */

import { createApp } from 'vue';
import SearchModal from './components/SearchModal.vue';

// Initialize Search Modal when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	// Create search modal container if it doesn't exist
	let searchContainer = document.getElementById('search-modal-app');

	if (!searchContainer) {
		searchContainer = document.createElement('div');
		searchContainer.id = 'search-modal-app';
		document.body.appendChild(searchContainer);
	}

	// Create and mount the Vue app
	const app = createApp(SearchModal);

	// Make WordPress data available to Vue
	app.config.globalProperties.$wordpress = {
		ajaxUrl: window.trendsData?.ajaxUrl || '/wp-admin/admin-ajax.php',
		nonce: window.trendsData?.nonce || '',
		siteUrl: window.trendsData?.siteUrl || '',
	};

	const searchModalInstance = app.mount('#search-modal-app');

	// Connect to search buttons/triggers
	const searchTriggers = document.querySelectorAll('.search-toggle, .mobile-search');

	searchTriggers.forEach(trigger => {
		trigger.addEventListener('click', e => {
			e.preventDefault();
			searchModalInstance.openModal();
		});
	});

	// Optional: Make search modal globally accessible
	window.trendsSearch = {
		open: () => searchModalInstance.openModal(),
		close: () => searchModalInstance.closeModal(),
	};
});
